import { render } from "./JobListingComponent.vue?vue&type=template&id=27618458&scoped=true"
import script from "./JobListingComponent.vue?vue&type=script&lang=js"
export * from "./JobListingComponent.vue?vue&type=script&lang=js"

import "./JobListingComponent.vue?vue&type=style&index=0&id=27618458&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27618458"]])

export default __exports__